import { useSelector } from 'react-redux'
import find from 'lodash/find'

import { RootState } from 'types'

export const useCurrentWorkspace = () => {
  const workspace = useSelector(({ workspace }: RootState) =>
    find(workspace.workspaces, { id: workspace.currentWorkspaceId }),
  )
  return workspace
}
